import { HelpCaption } from './captions/help-caption';
import { SupportTitle } from './captions/support-title';

export const HelpCenterNotFound = () => {
  return (
    <>
      <SupportTitle />
      <HelpCaption>Videos are coming soon</HelpCaption>
    </>
  );
};
